/** @jsx $jsx */
import { $jsx } from 'framework7';
import { usadosFunciones } from "../js/usadosFunciones";
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on;
  var usados = new usadosFunciones();
  var consultaID = localStorage.getItem('consultaID');
  $on('pageBeforeIn', function (event, page) {
    usados.listarVehiculos($f7, 0);
    console.log(consultaID);
    if (consultaID != 0 || !consultaID) {
      $(".fab").hide();
    }
  });
  $on('pageInit', function () {
    // create searchbar
    var searchbar = $f7.searchbar.create({
      el: '.searchbar',
      searchContainer: '.list',
      searchIn: '.item-title, .item-text',
      on: {
        search: function search(sb, query, previousQuery) {
          console.log(query, previousQuery);
        }
      }
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">

    <!-- Top Navbar -->
    <div class="navbar navbar-large">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link icon-only panel-open" data-panel="left">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
        <div class="title sliding">Usados</div>
        <div class="title-large">
          <div class="title-large-text">Usados</div>
        </div>
        <div class="subnavbar">
          <form class="searchbar">
            <div class="searchbar-inner">
              <div class="searchbar-input-wrap">
                <input type="search" placeholder="Busqueda rapida" />
                <i class="searchbar-icon"></i>
                <span class="input-clear-button"></span>
              </div>
              <span class="searchbar-disable-button if-not-aurora">Cancel</span>
            </div>
          </form>
        </div>
      </div>


    </div>
    <!-- Toolbar-->
    <!-- <div class="toolbar toolbar-bottom">
      <div class="toolbar-inner">
        <a href="#" class="link">Left Link</a>
        <a href="#" class="link">Left Link</a>
        <a href="#" class="link">Left Link</a>
        <a href="#" class="link">Left Link</a>
      </div>
    </div> -->
    <!-- Scrollable page content-->
    <!-- FAB para agregar nuevos vehiculos -->
    <div class="fab fab-extended fab-right-bottom color-green">
      <a href="/abm/">
        <i class="icon f7-icons if-not-md">plus</i>
        <i class="icon material-icons md-only">add</i>
        <!-- <div class="fab-text popup-open" href="#" data-popup=".popup-about">Agregar</div> -->
        <div class="fab-text" href="#">Agregar</div>
      </a>
    </div>
      
  <!-- End - FAB para agregar nuevos vehiculos -->
    <div class="page-content">
      <div class="block-title">Agregados recientemente</div>
      <div class="list media-list">
        <ul id="listadoUsados">
        </ul>
      </div>
    </div>
    <!-- End - Scrollable page content-->
    <!-- Popup de carga -->
    <div class="popup popup-about">
      <div class="block">
        <div class="block-title text-align-center">ALTA NUEVO VEHICULO</div>
        <p class="row text-align-right">
          <a class="" href="#"></a>
          <a class="" href="#"></a>
          <a class="button button-fill button-small color-pink popup-close" href="#">Cancelar</a>
        </p>
        <p class="alert">Todos los campos son obligatorios</p>
        <div class="list">
          <ul>
            <li>
              <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
              <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar modelo">
                <select name="marca">
                  <optgroup label="Japanese">
                    <option value="honda">Honda</option>
                    <option value="lexus">Lexus</option>
                    <option value="mazda">Mazda</option>
                    <option value="nissan">Nissan</option>
                    <option value="toyota">Toyota</option>
                  </optgroup>
                  <optgroup label="German">
                    <option value="audi">Audi</option>
                    <option value="bmw">BMW</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="vw">Volkswagen</option>
                    <option value="volvo">Volvo</option>
                  </optgroup>
                  <optgroup label="American">
                    <option value="cadillac">Cadillac</option>
                    <option value="chrysler">Chrysler</option>
                    <option value="dodge">Dodge</option>
                    <option value="ford">Ford</option>
                  </optgroup>
                </select>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title">Marca</div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
              <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar modelo">
                <select name="modelo">
                  <optgroup label="Japanese">
                    <option value="honda">Honda</option>
                    <option value="lexus">Test 1</option>
                    <option value="mazda">Mazda</option>
                    <option value="nissan">Nissan</option>
                    <option value="toyota">Toyota</option>
                  </optgroup>
                  <optgroup label="German">
                    <option value="audi">Audi</option>
                    <option value="bmw">BMW</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="vw">Volkswagen</option>
                    <option value="volvo">Volvo</option>
                  </optgroup>
                  <optgroup label="American">
                    <option value="cadillac">Cadillac</option>
                    <option value="chrysler">Chrysler</option>
                    <option value="dodge">Dodge</option>
                    <option value="ford">Ford</option>
                  </optgroup>
                </select>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title">Modelo</div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
              <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar version">
                <select name="version">
                  <optgroup label="Japanese">
                    <option value="honda">Test 2</option>
                    <option value="lexus">Lexus</option>
                    <option value="mazda">Mazda</option>
                    <option value="nissan">Nissan</option>
                    <option value="toyota">Toyota</option>
                  </optgroup>
                  <optgroup label="German">
                    <option value="audi">Audi</option>
                    <option value="bmw">BMW</option>
                    <option value="mercedes">Mercedes</option>
                    <option value="vw">Volkswagen</option>
                    <option value="volvo">Volvo</option>
                  </optgroup>
                  <optgroup label="American">
                    <option value="cadillac">Cadillac</option>
                    <option value="chrysler">Chrysler</option>
                    <option value="dodge">Dodge</option>
                    <option value="ford">Ford</option>
                  </optgroup>
                </select>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title">Version</div>
                  </div>
                </div>
              </a>
            </li>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="text" placeholder="PATENTE" />
                  <span class="input-clear-button"></span>
                </div>
              </div>
            </li>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="number" placeholder="AÑO" />
                  <span class="input-clear-button"></span>
                </div>
              </div>
            </li>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="text" placeholder="COLOR" />
                  <span class="input-clear-button"></span>
                </div>
              </div>
            </li>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <textarea placeholder="Comentarios"></textarea>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="toolbar tabbar tabbar-labels toolbar-bottom">
        <div class="toolbar-inner">
          <a href="#tab-1" class="tab-link">
            <i class="icon f7-icons if-not-md">floppy_disk</i>
            <i class="icon material-icons md-only">floppy_disk</i>
            <span class="tabbar-label">Guardar</span>
          </a>

          <a href="#tab-3" class="tab-link">
            <i class="icon f7-icons if-not-md">cloud_upload_fill</i>
            <i class="icon material-icons md-only">file_upload</i>
            <span class="tabbar-label">Imagenes</span>
          </a>
        </div>
      </div>

    </div>
    <!-- Popup de carga -->
  </div>
`
    }
    ;
}
framework7Component.id = 'd00203c6e5';
export default framework7Component;